module.exports = __webpack_public_path__ + "8e9505ddef018356ad436af0093c6afd.fbx";